/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Embed_Captions_Important_TextInputs */

const en_embed_captions_important_text = /** @type {(inputs: Embed_Captions_Important_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Closed captioning is embedded in the final output. No transcode or encoding will be performed on the video file itself. Ensure your video is in the correct format and codec before submission.`)
};

const fr_embed_captions_important_text = /** @type {(inputs: Embed_Captions_Important_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le sous-titrage est incruste dans la sortie finale. Aucune transcodification ni encodage ne sera effectue sur le fichier video lui-meme. Assurez-vous que votre video est au bon format et codec avant la soumission.`)
};

const de_embed_captions_important_text = /** @type {(inputs: Embed_Captions_Important_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Untertitel sind in die finale Ausgabe eingebettet. Es findet keine Transkodierung oder Kodierung der Videodatei selbst statt. Bitte stellen Sie sicher, dass Ihr Video vor dem Einreichen das richtige Format und den richtigen Codec aufweist.`)
};

const it_embed_captions_important_text = /** @type {(inputs: Embed_Captions_Important_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I sottotitoli sono incorporati nell'output finale. Non verrà eseguita alcuna transcodifica o codifica sul file video. Assicurati che il video sia nel formato e nel codec corretti prima dell'invio.`)
};

const ru_embed_captions_important_text = /** @type {(inputs: Embed_Captions_Important_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Субтитры встроены в итоговый файл. Перекодирование или кодирование самого видеофайла не производится. Перед отправкой убедитесь, что ваше видео имеет правильный формат и кодек.`)
};

const es_embed_captions_important_text = /** @type {(inputs: Embed_Captions_Important_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Los subtítulos están integrados en el resultado final. No se realizará ninguna transcodificación ni codificación en el archivo de video. Asegúrese de que su video tenga el formato y el códec correctos antes de enviarlo.`)
};

const zh_cn2_embed_captions_important_text = /** @type {(inputs: Embed_Captions_Important_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`字幕将嵌入到最终输出文件中。视频文件本身不会进行转码或编码。请确保您的视频在提交前格式和编码正确。`)
};

const ja_embed_captions_important_text = /** @type {(inputs: Embed_Captions_Important_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`最終出力にはクローズドキャプションが埋め込まれます。ビデオファイル自体にはトランスコードやエンコードは行われません。提出前に、ビデオのフォーマットとコーデックが正しいことをご確認ください。`)
};

const hi_embed_captions_important_text = /** @type {(inputs: Embed_Captions_Important_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो के अंतिम आउटपुट में क्लोज्ड कैप्शनिंग शामिल है। वीडियो फ़ाइल पर कोई ट्रांसकोड या एन्कोडिंग नहीं की जाएगी। सबमिशन से पहले सुनिश्चित करें कि आपका वीडियो सही फॉर्मेट और कोडेक में है।`)
};

const pt_pt2_embed_captions_important_text = /** @type {(inputs: Embed_Captions_Important_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As legendas ocultas estão incorporadas no arquivo final. Não será feita nenhuma transcodificação ou codificação no arquivo de vídeo em si. Certifique-se de que seu vídeo esteja no formato e codec corretos antes do envio.`)
};

/**
* | output |
* | --- |
* | "Closed captioning is embedded in the final output. No transcode or encoding will be performed on the video file itself. Ensure your video is in the correct f..." |
*
* @param {Embed_Captions_Important_TextInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const embed_captions_important_text = /** @type {((inputs?: Embed_Captions_Important_TextInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Embed_Captions_Important_TextInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_embed_captions_important_text(inputs)
	if (locale === "de") return de_embed_captions_important_text(inputs)
	if (locale === "it") return it_embed_captions_important_text(inputs)
	if (locale === "ru") return ru_embed_captions_important_text(inputs)
	if (locale === "es") return es_embed_captions_important_text(inputs)
	if (locale === "zh-CN") return zh_cn2_embed_captions_important_text(inputs)
	if (locale === "ja") return ja_embed_captions_important_text(inputs)
	if (locale === "hi") return hi_embed_captions_important_text(inputs)
	if (locale === "pt-PT") return pt_pt2_embed_captions_important_text(inputs)
	return en_embed_captions_important_text(inputs)
});